/**
 * The product name as a person sees it.
 *
 * Every user-facing mention — page titles, the app header, provenance wording,
 * the PDF source label — reads this, so renaming the product in the UI is a
 * one-line change here rather than a hunt through prose.
 *
 * Deliberately *not* used for anything a machine depends on. Package names,
 * environment variables, cookie names, CSS class prefixes, the CSRF header and
 * the print-readiness global still spell the old name, because changing those
 * breaks running installs, stored sessions and existing configuration. Those
 * move on their own schedule — see `docs/backlog/rename.md`.
 *
 * The one place this constant cannot reach is `apps/web/index.html`, which is
 * static markup loaded before any script runs.
 */
export const PRODUCT_NAME = 'ReportPad';
//# sourceMappingURL=branding.js.map